import Sticky from 'react-stickynode';
import styled, { createGlobalStyle } from 'styled-components';
import { Heading } from '@lendi-ui/typography';

import Stack from '../Stack';

const GlobalStyle = createGlobalStyle`
  // Hide app snapshot bottom border to show it on the page header
  .snapshot-wrapper {
    box-shadow: none;
    border-bottom: 1px solid rgb(227, 227, 227);
  }
`;

export const ChildrenWrapper = styled.div`
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: start;
  width: 100%;

  padding-left: calc(1.5 * var(--lendi-ui-size));
  padding-right: calc(1.5 * var(--lendi-ui-size));
  display: grid;
  grid-template-columns: auto 1fr auto;
  height: 76px;

  background-color: rgba(255, 255, 255, 1);
  styled & h3 {
    margin-bottom: 0;
    line-height: 115%;
  }

  & button {
    max-height: 40px;
  }

  box-shadow: rgba(0, 0, 0, 0.1) -3px 3px 3px 0px, rgba(0, 0, 0, 0.12) -3px 3px 4px 0px,
    rgba(0, 0, 0, 0.14) -8px 1px 8px 0px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StickyTitle = styled.div`
  margin-right: auto;
  margin-top: 12px;

  // overflow for long title
  max-height: 64px;
  overflow: hidden;
`;
export const StickyActions = styled.div`
  margin-left: auto;
  margin-top: 12px;
`;

interface StickyHeaderProps {
  children?: React.ReactNode;
  title: string;
  actionsContainerId?: string;
}

/**
 * @example with portal
 * <PageHeader title="Applicants" actionsContainerId={'applicants-action-buttons'} />
 *
 * @example without portal
 * <PageHeader title="Applicants">
 *   <Button variant="empty" before={<Add height={'18px'} width={'18px'} />} data-component="button-add-applicant">
 *      Test
 *   </Button>
 * </PageHeader>
 */
export default function PageHeader(props: StickyHeaderProps) {
  const { children, title, actionsContainerId } = props;

  return (
    <>
      <GlobalStyle />
      <Sticky innerZ={1} top={56}>
        <ChildrenWrapper>
          <StickyTitle>
            <Heading size="md" mb="sm">
              {title}
            </Heading>
          </StickyTitle>
          <StickyActions>
            <Stack halign="justify">
              <ActionsContainer id={actionsContainerId}>{children}</ActionsContainer>
            </Stack>
          </StickyActions>
        </ChildrenWrapper>
      </Sticky>
    </>
  );
}
